import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import appReducers from './reducers';
import commonReducers from './../ui/src/reducers.js';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import { browserHistory } from 'react-router';

let composeEnhancers;
if (typeof window !== 'undefined') {
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
} else {
    composeEnhancers = compose;
}

export default function configureStore(preloadedState) {
    if (!preloadedState) {
        preloadedState = {};
    }
    return createStore(
        combineReducers(Object.assign({}, Object.assign({}, commonReducers, appReducers), {
            routing: routerReducer
        })),
        preloadedState,
        composeEnhancers(
            applyMiddleware(
                routerMiddleware(browserHistory),
                thunkMiddleware
            )
        )
    );
}


// WEBPACK FOOTER //
// ./src/app/configureStore.js